import BannerComp from "../../components/BannerComp";
import FeatureCard from "../../components/FeatureCard";
import FeatureFlow from "../../components/FeatureFlow";
import FeatureImageContent from "../../components/FeatureImageContent";
import ImageTextSection from "../../components/ImageTextSection";
import Seo from "../../components/Seo";
import { featuresCardData, stepper } from "../../data/AdvancedWood";
import { createBreadcrumbSchema, createWebPageSchema } from "../../lib/seo";

import section1Image from "./woundcare_section1.webp";
import section2Image from "./woundcare_section2.webp";
import section3Image from "./woundcare_section3.webp";

const seo = {
  title: "Wound Care Solutions | MIT4Doctors",
  description:
    "MITSI uses placental grafts to treat wounds that haven't healed in a month. This cost-effective treatment is covered by Medicare, Medicaid, and top insurers.",
  schema: [
    createWebPageSchema({
      path: "/services/advance-wound-care",
      title: "Wound Care Solutions",
      description:
        "MITSI uses placental grafts to cure wounds that have not healed in over a month. This treatment is cost-effective. Medicare, Medicaid, and other top insurance firms cover it.",
    }),
    createBreadcrumbSchema(
      "/services/advance-wound-care",
      "Wound Care Solutions",
    ),
  ],
};

export default function AdvancedWoundCare() {
  return (
    <>
      <Seo
        title={seo.title}
        metaTitle={seo.title}
        description={seo.description}
        canonicalPath="/services/advance-wound-care"
        schema={seo.schema}
      />
      <BannerComp
        heading="Wound Care Solutions"
        paragraph="MITSI uses placental grafts to cure wounds that have not healed in over a month. This treatment is cost-effective. Medicare, Medicaid, and other top insurance firms cover it."
        centered
        BannerBgImg="/img/banners/advancewood_hero.webp"
      />

      <ImageTextSection
        image={section1Image}
        imageAlt="Our Advanced Placental Graft for Wound Care"
        imagePosition="left"
        title="Our Advanced Placental Graft for Wound Care"
        description="We not only enhance patient care but also back up healthcare providers. We source materials ethically, use reliable treatments, and assist with billing. This also helps your practice grow financially. Our placental graft solution is for cases where traditional wound care has failed. It is for wounds with less than 50% closure after 30 days. These grafts speed recovery. They heal in a more targeted, effective way. Below are the defining features that set our product apart."
        highlightWords="Wound Care"
      />

      <FeatureFlow
        heading="Key Benefits of Our Placental Graft Solution"
        highlights={["Graft", "Solution"]}
        paragraph="Explore the key benefits of our placental graft solution, designed to support precise procedures, efficient treatment, and improved patient outcomes."
        steps={stepper}
      />

      <FeatureImageContent
        heading="Advanced Healing for Tough Wounds"
        description="MITSI offers you affordable treatment covered by Medicare and Medicaid. It easily fits into your practice with complete help on billing."
        buttonLabel="Get Started"
        buttonUrl="/contact-us"
        imageAlt="Advanced Healing for Tough Wounds"
      />

      <ImageTextSection
        image={section2Image}
        imageAlt="High-Impact Wound Care without Financial Barriers"
        imagePosition="left"
        title="High-Impact Wound Care without Financial Barriers"
        description="Partnering with Medical Imaging Technology Services gives you an advanced wound care product. You also get support to improve patient outcomes and optimize your workflow. Our placental graft is effective."
        highlightWords="Financial Barriers"
        subSections={[
          {
            heading: "Ready to Transform Your Wound Care Approach?",
            description:
              "MITSI advanced wound care solution treats tough wounds. It is ethically sourced, accessible, and highly effective. Our product aims to improve chronic wound care and support post-op recovery. It balances patient outcomes with provider efficiency.",
          },
        ]}
      />
      <FeatureCard
        sectionTitle="Key Applications for Our Wound Care Graft"
        sectionDescription="Our advanced placental graft is very versatile. It is especially useful when other treatments have failed to heal. Below are the primary applications where our solution can enhance patient outcomes:"
        highlightText="Wound Care Graft"
        features={featuresCardData}
      />

      <ImageTextSection
        image={section3Image}
        imageAlt="Offer Healing Better, Faster, & Smarter"
        imagePosition="left"
        title="Offer Healing Better, Faster, & Smarter"
        description="Contact us today to learn about our placental graft wound care solution. Discover how MITSI can enhance your practice's wound care services."
        highlightWords="Smarter"
        subHeading="Transform patient care, refine operations, and improve wound healing with our Wound Care Service."
        buttonLabel="Get Started"
        buttonUrl="/contact-us"
      />
    </>
  );
}
